import http from "../http-common";
import { ISchedulerJob, ISchedulerJobRun } from "../types/MongerlabCustomer";

const getAllJobs = () => {
  return http.get<ISchedulerJob[]>(`/scheduler/jobs`);
};

const triggerJob = (jobKey: string) => {
  return http.post<ISchedulerJobRun>(`/scheduler/jobs/${jobKey}/trigger`);
};

const getJobRuns = (jobKey: string, page = 0, size = 20) => {
  return http.get<{ data: ISchedulerJobRun[]; page: number; size: number; totalElements: number; totalPages: number }>(
    `/scheduler/jobs/${jobKey}/runs?page=${page}&size=${size}`
  );
};

const SchedulerJobService = {
  getAllJobs,
  triggerJob,
  getJobRuns,
};

export default SchedulerJobService;
